import { Link, NavLink } from "react-router-dom"

function Sidebar() {
    // const router = useRouter()
    console.log(NavLink)
    return (
        <>
            <div className="sidebar">
                <div className="brand-logo">
                    <Link to="/" className="full-logo">
                            <img src="./images/logoi.png" alt="" width="30" />
                        
                    </Link>
                    {/* <Link to="/">
                        <a className="mini-logo">
                            <img src="./images/logoi.png" alt="" width="40" />
                        
                    </Link> */}
                </div>
                <div className="menu">
                    <ul>
                        <li>
                            <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i class="ri-layout-grid-fill"></i>
                                    </span>
                                    <span className="nav-text">Dashboard</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/bids" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i class="ri-briefcase-line"></i>
                                    </span>
                                    <span className="nav-text">Bids</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/saved" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i class="ri-heart-line"></i>
                                    </span>
                                    <span className="nav-text">Saved</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/collection" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i class="ri-star-line"></i>
                                    </span>
                                    <span className="nav-text">Collection</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/wallet" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i className="ri-wallet-line"></i>
                                    </span>
                                    <span className="nav-text">Wallet</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/profile" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i class="ri-account-box-line"></i>
                                    </span>
                                    <span className="nav-text">Profile</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/settings-profile" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i className="ri-settings-3-line"></i>
                                    </span>
                                    <span className="nav-text">Settings</span>
                                
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/signin" className={({ isActive }) => isActive ? "active" : ""}>
                                    <span>
                                        <i className="ri-logout-circle-line"></i>
                                    </span>
                                    <span className="nav-text">Signout</span>
                                
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}
export default Sidebar
